module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?c32505e8c654310ece1da4e1c10eeb57";